import { useCallback } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { useUpdateSiteControllerSettingNeppan } from "../../../../model/neppan/use-case";

import type { SiteControllerSettingNeppanFormModel } from "../../../../model/neppan/type";

type Props = {
	viewModel: SiteControllerSettingNeppanFormModel["ViewModel"];
	onResetViewModel: () => void;
};

export const useSettingsSiteControllerNeppan = ({ viewModel, onResetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { onUpdate: _onUpdate } = useUpdateSiteControllerSettingNeppan({ viewModel });
	const onUpdate = useCallback(async () => {
		showLoadingScreenCallback();

		const { errors } = await _onUpdate().finally(hideLoadingScreenCallback);

		if (!errors) {
			notifyUserEventInfo({
				title: "サイコン設定（ねっぱん！）を更新しました",
			});
			onResetViewModel();
		}
	}, [_onUpdate, hideLoadingScreenCallback, onResetViewModel, showLoadingScreenCallback]);

	return {
		onUpdate,
	};
};
